<button class="close" style="float: right;
min-width: auto;" mat-button (click)="onNoClick()">X</button>
<h2>Finalizar Autoevaluación</h2> 
<div mat-dialog-content>
    ¿Está segura que desea <b>finalizar</b> la Autoevaluación?
</div>
<div mat-dialog-actions>
  <button mat-button class="btn-cancelar" mat-dialog-close>Cancelar</button>
  <button mat-button class="btn-confirmar" (click)="confirmar()">Confirmar</button>
</div>